import React from "react";

/**
 * LinkedIn COMPANY-PAGE banner — 1128×191.
 *
 * The LinkedIn profile-picture avatar overlays the BOTTOM-LEFT corner of every
 * banner. At our banner aspect ratio that overlay covers roughly the first
 * ~260px from the left and bottom ~130px down. Any text or logo placed inside
 * that "shadow" gets obscured by the circular avatar — exactly what happened
 * to the first version of this banner.
 *
 * Composition rules used here:
 *   ▸ Bottom-left "AVATAR SAFE ZONE": 0–260px from left, 60–191px from top
 *     must contain ZERO type or logos. We let the photo show through here.
 *   ▸ Headline lives in the TOP-LEFT quadrant only — out of the avatar zone.
 *   ▸ Brand wordmark + URL sit RIGHT, vertically centred, untouched by avatar.
 */
export default function LinkedInBanner() {
  return (
    <div
      style={{
        width: 1128,
        height: 191,
        position: "relative",
        overflow: "hidden",
        background: "#070A0D",
        fontFamily: "Montserrat, system-ui, -apple-system, sans-serif",
        color: "#F5F7FA",
      }}
    >
      {/* Background photo */}
      <img
        src="/projects/thornybush/thornybush_sunset.webp"
        alt=""
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "62% 50%",
          filter: "saturate(1.05) contrast(1.05)",
        }}
      />

      {/* Top gradient — keeps the headline readable */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(7,10,13,0.85) 0%, rgba(7,10,13,0.55) 38%, rgba(7,10,13,0.0) 70%)",
        }}
      />

      {/* Right-side veil — keeps the wordmark readable against bright sky */}
      <div
        style={{
          position: "absolute",
          right: 0, top: 0, bottom: 0,
          width: "40%",
          background:
            "linear-gradient(270deg, rgba(7,10,13,0.78) 0%, rgba(7,10,13,0.45) 45%, rgba(7,10,13,0) 100%)",
        }}
      />

      {/* HEADLINE — top-left ONLY, fully above the avatar's overlay band.
          Pinned to top:14 instead of vertically centred so it does not collide. */}
      <div
        style={{
          position: "absolute",
          top: 18,
          left: 40,
          right: 380,
          maxWidth: 660,
        }}
      >
        <div
          style={{
            fontSize: 10,
            letterSpacing: "0.32em",
            textTransform: "uppercase",
            color: "#2bc0cf",
            fontWeight: 600,
            marginBottom: 8,
          }}
        >
          Universal Water Systems
        </div>
        <div
          style={{
            fontSize: 34,
            lineHeight: 1.02,
            letterSpacing: "-0.022em",
            fontWeight: 300,
            color: "#F5F7FA",
          }}
        >
          Taking{" "}
          <span style={{ color: "#2bc0cf", fontWeight: 600 }}>pure water</span>
          {" "}everywhere.
        </div>
      </div>

      {/* RIGHT BLOCK — wordmark + URL, vertically centred, untouched by avatar. */}
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          right: 40,
          width: 280,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          justifyContent: "center",
          gap: 10,
        }}
      >
        <img
          src="/brand/hidroverse_wordmark_light.png"
          alt="HidroVerse"
          style={{
            height: 140,
            width: "auto",
            display: "block",
            objectFit: "contain",
            objectPosition: "right center",
            filter: "drop-shadow(0 2px 14px rgba(0,0,0,0.7))",
          }}
        />
        <div
          style={{
            fontSize: 11,
            letterSpacing: "0.28em",
            textTransform: "uppercase",
            color: "rgba(245,247,250,0.8)",
            fontWeight: 500,
          }}
        >
          hidroverse.co.za
        </div>
      </div>

      {/* OPTIONAL — visual debug guide for the avatar safe zone. Uncomment to verify.
      <div style={{
        position: "absolute", left: 0, bottom: 0, width: 260, height: 131,
        border: "1px dashed rgba(255,0,0,0.55)", pointerEvents: "none",
      }} /> */}
    </div>
  );
}
